import React from "react";
import useWithStore from "@/Hooks/useWithStore";
import Select from "react-select";
import {Error} from "@/Components/Error";
import "@/Scss/Components/formSelect.scss";

const BaseSelect = (props) => {
    const {
        name = '',
        value = {},
        defaultValue = {},
        onChange,
        options = [],
        maxMenuHeight = 180,
        autoFocus = false,
        isSearchable = true,
        isMulti = false,
        isDisabled = false,
        menuIsOpen = false,
        className = '',
        classNamePrefix = '',
        placeholder,
        message = '',
        noOptionsMessage = 'Не найдено',
    } = props;

    const handleChange = (selectedOption) => {
        if (onChange) {
            onChange(selectedOption);
        }
    };

    return (
        <div className={`formSelect`}>
            <Select
                name={name}
                value={value}
                defaultValue={defaultValue}
                onChange={handleChange}
                options={options}
                maxMenuHeight={maxMenuHeight}
                autoFocus={autoFocus}
                isSearchable={isSearchable}
                isMulti={isMulti}
                isDisabled={isDisabled}
                // menuIsOpen={menuIsOpen}
                className={className}
                classNamePrefix={classNamePrefix}
                placeholder={placeholder}
                noOptionsMessage={() => (noOptionsMessage)}
                theme={theme => ({
                    ...theme,
                    borderRadius: 0,
                    colors: {
                        ...theme.colors,
                        primary25: '#B1CBC3',
                        primary: 'black',
                    },
                })}
            />
            <Error message={message} />
        </div>
    );
}

export default useWithStore(BaseSelect);
